const medical =
{
    //
};

export default medical ;